import React from 'react'
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom'

import Landing from './containers/Landing'


export const AppRouterPrivate = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => {

    console.log(`Enter into AppRouterPrivate.js (isAuthenticated: ${isAuthenticated}, location: ${window.location})`)
     
    return (
        <Route { ...rest }
            component={ (props) => (
                ( isAuthenticated )
                    ? ( <Component { ...props } /> )
                    : ( <Landing />  )
            )}
        
        />
    )

}

export default AppRouterPrivate;

AppRouterPrivate.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}